import React, { useState } from "react"
import clsx from "clsx"
import { useCustomName } from "hooks"
import { useSolutionLevelReportExportContext } from "contexts/SolutionLevelReportExportContext"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import ReportableFieldLocationAnswerFiltersLocationDetailsFacilitySelect from "./ReportableFieldLocationAnswerFiltersLocationDetailsFacilitySelect"
import ReportableFieldsLocationAnswerFiltersLocationDetailsSelectedFacilities from "./ReportableFieldsLocationAnswerFiltersLocationDetailsSelectedFacilities"

const ReportableFieldLocationAnswerFiltersDetails = () => {
  const {
    addAllFacilityDepartmentsToReportableFieldLocationAnswerFilters,
    removeAllFacilityDepartmentsFromReportableFieldLocationAnswerFilters,
  } = useSolutionLevelReportExportContext()

  const [selectedFacilityIds, setSelectedFacilityIds] = useState([])

  const { pluralName: departmentsName } = useCustomName(DEPARTMENT_KEY)

  const updateSelectedFacilities = (facilityIds) => {
    const currentSelectedFacilityIds = selectedFacilityIds

    const facilityIdsToAdd = facilityIds.filter((id) => !currentSelectedFacilityIds.includes(id))
    facilityIdsToAdd.forEach(addAllFacilityDepartmentsToReportableFieldLocationAnswerFilters)

    const facilityIdsToRemove = currentSelectedFacilityIds.filter((id) => !facilityIds.includes(id))
    facilityIdsToRemove.forEach(removeAllFacilityDepartmentsFromReportableFieldLocationAnswerFilters)

    setSelectedFacilityIds(facilityIds)
  }

  return (
    <>
      <ReportableFieldLocationAnswerFiltersLocationDetailsFacilitySelect
        className={clsx(selectedFacilityIds.length > 0 && "mb-4")}
        onChange={updateSelectedFacilities}
        values={selectedFacilityIds}
      />
      {
        selectedFacilityIds.length > 0 && (
          <div>
            <span className="block mb-4">{departmentsName}:</span>
            <ReportableFieldsLocationAnswerFiltersLocationDetailsSelectedFacilities selectedFacilityIds={selectedFacilityIds} />
          </div>
        )
      }
    </>
  )
}

export default ReportableFieldLocationAnswerFiltersDetails
